import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'firebase';
import { parsePhoneNumber } from 'libphonenumber-js';
import { ToastrService } from 'ngx-toastr';
import { Quiniela } from 'src/app/models/quiniela';
import { AuthService } from 'src/app/services/auth.service';
import { QuinielasService } from 'src/app/services/quinielas.service';
import { SmsService } from 'src/app/services/sms.service';

@Component({
  selector: 'app-quinielas-page',
  templateUrl: './quinielas-page.component.html',
  styleUrls: ['./quinielas-page.component.css']
})
export class QuinielasPageComponent implements OnInit {
  quinielas: Array<Quiniela> = [];
  user: User = null;
  isAuthenticated = false;
  isLoading = true;

  constructor(
    private authService: AuthService,
    private QuinielasService: QuinielasService,
    private router: Router,
    private toastr: ToastrService,
    private SmsService: SmsService,
  ) { }

  ngOnInit(): void {
    this.getCurrentUser();
  }

  getCurrentUser(): void {
    this.authService.getCurrentUser().subscribe((response) => {
      if (response) {
        this.user = response;
        this.isAuthenticated = true;
        this.getAllQuinielasDeUnUsuario();
        return;
      }
      this.isAuthenticated = false;
    });
  }

  // Obtener las Quinielas
  getAllQuinielasDeUnUsuario(): void {
    this.isLoading = true;

    this.QuinielasService.getAllQuinielasDeUnUsuario(this.user.email).subscribe((items) => {
      // Setting up quinielas
      this.quinielas = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as Quiniela)
      );
      this.isLoading = false;
    });


    /*
    this.QuinielasService.getAllQuinielas().subscribe((items) => {
      // Setting up quinielas
      this.quinielas = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as Quiniela)
      );

      // Vector de las Quinielas del usuario logueado
      var quinielasCurrentUser = [];

      // Filtrar las Quinielas de este Usuario
      for (var i = 0; i < this.quinielas.length; i += 1) {
        if (this.quinielas[i].user == this.user.email) {
          quinielasCurrentUser.push(this.quinielas[i])
          console.log(this.quinielas[i]);
        }
      }

      // Guardandolas en el Array de Quinielas
      this.quinielas = quinielasCurrentUser;

      // Terminar cargando
      this.isLoading = false;
    });
      */
  }

  // Agregar una nueva Quiniela
  onSubmit() {
    // Control para evitar submit en caso que falte algo
    let error = false;

    // Validando los inputs que no esten vacios
    const inputs = ["Telefono", "Email", "Titulo", "Descripcion", "URL", "Precio", "Moneda", "Porcentaje", "DatosPago"];
    inputs.map(function (id) {
      document.getElementById(`div-${id}`).classList.remove('form-control-google-error');
      if ((<HTMLInputElement>document.getElementById(id)).value == '') {
        document.getElementById(`div-${id}`).classList.add('form-control-google-error');
        error = true
      }
    });

    if (error) {
      // Enviar el Alerta
      this.toastr.error('Por favor, revise que todos los campos estén llenos para poder crear su quiniela.');
    }

    // Validar que no exista el URL
    var url = (<HTMLInputElement>document.getElementById("URL")).value
    const urlArray = url.split(" ");
    console.log(urlArray.length, url, urlArray)

    const QS = this.QuinielasService.getQuinielaByURL(url).subscribe((items) => {
      // Setting up tasks
      var quinielas = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as Quiniela)
      );
      QS.unsubscribe();


      if (urlArray.length == 1) {
        if (quinielas.length != 0) {
          // Enviar el Alerta
          document.getElementById(`div-URL`).classList.add('form-control-google-error');
          this.toastr.error('Lamentablemente, la palabra clave para formar el link que está utilizando ya está ocupado. Por favor, puede proporcionar otra palabra clave para su quiniela.');
          error = true;
        }
      } else {
        error = true;
        // Enviar el Alerta
        this.toastr.error('Por favor, asegúrese de que el URL de la quiniela no contenga espacios. Los espacios no son permitidos en los URLs.');
      }



      // Si error es Falso entonces se procede a crear el Objeto y enviar por medio del Servicio
      if (!error) {
        // Limpiar las alertas del Formulario
        inputs.map(function (id) {
          document.getElementById(`div-${id}`).classList.remove('.form-control-google-error');
        });

        // Cerrando Modal
        (<HTMLInputElement>document.getElementById("CloseButton")).click();

        // Enviar el Alerta
        this.toastr.success('Se ha creado con éxito su Quiniela!');

        // Obteniendo todos las Formas de Pago selecionadas 
        const checkboxes = document.querySelectorAll('input[name="FormaPago"]:checked');

        // Introduciendolas en un Vector
        let FormasPago = [];
        checkboxes.forEach((checkbox) => {
          FormasPago.push((checkbox as HTMLInputElement).value);
        });
        // Imprimiendo las Formas de Pago
        console.log(FormasPago)

        // Creando el Objeto con el Modelo
        const dataQuiniela: Quiniela = {
          email: (<HTMLInputElement>document.getElementById("Email")).value,
          titulo: (<HTMLInputElement>document.getElementById("Titulo")).value,
          descripcion: (<HTMLInputElement>document.getElementById("Descripcion")).value,
          url: (<HTMLInputElement>document.getElementById("URL")).value.toLocaleLowerCase(),
          datos_de_pago: (<HTMLInputElement>document.getElementById("DatosPago")).value,
          precio: parseInt((<HTMLInputElement>document.getElementById("Precio")).value),
          moneda: (<HTMLInputElement>document.getElementById("Moneda")).value,
          porcentaje: parseInt((<HTMLInputElement>document.getElementById("Porcentaje")).value),
          activa: false,
          telefono: (<HTMLInputElement>document.getElementById("Telefono")).value,
          user: this.user.email,
          numero: 0,
          pote: 0,
          empezada: false,
          fecha: new Date().toLocaleDateString(),
        };

        // Enviar a Firebase mediante el Servicio
        this.QuinielasService.createQuiniela(dataQuiniela).then((res) => {
          console.log("Se ha creado con exito la Quiniela", dataQuiniela);

          // Enviar SMS avisando que se registro con exito
          var numero = "+584122924248";
          var texto = "*TuQuinielaYa:* La quiniela " + (<HTMLInputElement>document.getElementById("Nombre")).value + " ha sido creada por el usuario: " + this.user.email + " \n Titulo: " + dataQuiniela.titulo + " \n Telefono:" + dataQuiniela.telefono + " \n URL: " + dataQuiniela.url + " \n Precio: " + dataQuiniela.precio + " \n Moneda: " + dataQuiniela.moneda;
          this.SmsService.enviar(numero, texto);

          // Limpiar el Formulario
          (<HTMLInputElement>document.getElementById("Nombre")).value = '';
          (<HTMLInputElement>document.getElementById("Copa")).value = '';
          (<HTMLInputElement>document.getElementById("Email")).value = '';
          (<HTMLInputElement>document.getElementById("Titulo")).value = '';
          (<HTMLInputElement>document.getElementById("Descripcion")).value = '';
          (<HTMLInputElement>document.getElementById("DatosPago")).value = '';
          (<HTMLInputElement>document.getElementById("URL")).value = '';
          (<HTMLInputElement>document.getElementById("Precio")).value = '';
          (<HTMLInputElement>document.getElementById("Moneda")).value = '';
          (<HTMLInputElement>document.getElementById("Porcentaje")).value = '';
          (<HTMLInputElement>document.getElementById("Telefono")).value = '';
          (<HTMLInputElement>document.getElementById("Zelle")).checked = false;
          (<HTMLInputElement>document.getElementById("PagoMovil")).checked = false;
          (<HTMLInputElement>document.getElementById("Transferencia")).checked = false;
          (<HTMLInputElement>document.getElementById("Efectivo")).checked = false;

        });
      }
    });
  }

  editar(quiniela: Quiniela) {
    // Control para evitar submit de editar en caso que falte algo
    let error = false;

    // ID de la Quiniela
    var id = quiniela.$key;

    // Validando los inputs que no esten vacios
    const inputs = ["Telefono-" + id, "Email-" + id, "Titulo-" + id, "URL-" + id, "Precio-" + id, "Moneda-" + id, "Porcentaje-" + id, "DatosPago-" + id];
    inputs.map(function (id) {
      document.getElementById(id).classList.remove('is-invalid')
      if ((<HTMLInputElement>document.getElementById(id)).value == '') {
        document.getElementById(id).classList.add('is-invalid')
        error = true
      } else {
        document.getElementById(id).classList.add('is-valid')
      }
    });

    // Si error es Falso entonces se procede a crear el Objeto y enviar por medio del Servicio
    if (!error) {
      // Limpiar las alertas del Formulario
      inputs.map(function (id) {
        document.getElementById(id).classList.remove('is-valid')
      });

      // Cerrando Modal
      (<HTMLInputElement>document.getElementById("CloseButton-" + id)).click();

      // Enviar el Alerta
      this.toastr.success('Se ha editado con éxito su Quiniela!');

      // Obteniendo todos las Formas de Pago selecionadas 
      const checkboxes = document.querySelectorAll('input[name="' + id + '"]:checked');

      // Introduciendolas en un Vector
      let FormasPago = [];
      checkboxes.forEach((checkbox) => {
        FormasPago.push((checkbox as HTMLInputElement).value);
      });
      // Imprimiendo las Formas de Pago
      console.log(FormasPago)

      // Creando el Objeto con el Modelo
      const dataQuiniela: Quiniela = {
        email: (<HTMLInputElement>document.getElementById("Email-" + id)).value,
        titulo: (<HTMLInputElement>document.getElementById("Titulo-" + id)).value,
        descripcion: (<HTMLInputElement>document.getElementById("Descripcion-" + id)).value,
        url: quiniela.url,
        datos_de_pago: (<HTMLInputElement>document.getElementById("DatosPago-" + id)).value,
        precio: parseInt((<HTMLInputElement>document.getElementById("Precio-" + id)).value),
        moneda: (<HTMLInputElement>document.getElementById("Moneda-" + id)).value,
        porcentaje: parseInt((<HTMLInputElement>document.getElementById("Porcentaje-" + id)).value),
        activa: quiniela.activa,
        telefono: (<HTMLInputElement>document.getElementById("Telefono-" + id)).value,
        user: this.user.email,
        numero: quiniela.numero,
        pote: quiniela.pote,
        empezada: quiniela.empezada,
        fecha: quiniela.fecha,
      };

      // Enviar a Firebase mediante el Servicio
      this.QuinielasService.updateQuiniela(dataQuiniela, id).then((res) => {
        console.log("Se ha editado con exito la Quiniela", dataQuiniela);
      });

    }

  }

}
